/**
 * Liste complète des indicateurs klinecharts v9 disponibles.
 * `overlay: true` = superposé sur le graphique de prix (pane candle_pane)
 * `overlay: false` = affiché dans un sous-panneau distinct
 */
export const INDICATORS = [
  // ==== STRUCTURE DE MARCHÉ (propriétaire, SVG overlay) ====
  { name: "ZII",   label: "ZII (Zones d'Intervention Institutionnelle)",  overlay: true, cat: "Structure", custom: true },
  { name: "ZRI",   label: "ZRI (Zones de Rejet Importantes)",             overlay: true, cat: "Structure", custom: true },
  { name: "DP",    label: "DP (Décalages de Prix / imbalances)",          overlay: true, cat: "Structure", custom: true },
  { name: "RL",    label: "RL (Réservoirs de Liquidité)",                 overlay: true, cat: "Structure", custom: true },
  { name: "OB",    label: "Order Blocks (zones institutionnelles)",       overlay: true, cat: "Structure", custom: true },
  { name: "BB",    label: "Breaker Blocks (zones cassées & re-testées)",  overlay: true, cat: "Structure", custom: true },
  { name: "CISD",  label: "CISD (cassures de structure BOS)",             overlay: true, cat: "Structure", custom: true },
  { name: "FVG",   label: "Fair Value Gaps (imbalances)",                 overlay: true, cat: "Structure", custom: true },
  { name: "SWING", label: "Swing High/Low (points pivots)",               overlay: true, cat: "Structure", custom: true },
  { name: "CRT",   label: "CRT (Candle Range Theory)",                    overlay: true, cat: "Structure", custom: true },
  { name: "UNMIT", label: "Filtre : zones non mitigées uniquement (OB/FVG)", overlay: true, cat: "Structure", custom: true },

  // ==== OVERLAY (sur le pane des bougies) ====
  { name: "MA",   label: "Moyenne Mobile (MA)",       overlay: true,  cat: "Tendance" },
  { name: "EMA",  label: "EMA (Exponentielle)",       overlay: true,  cat: "Tendance" },
  { name: "SMA",  label: "SMA (Lissée)",              overlay: true,  cat: "Tendance" },
  { name: "BBI",  label: "BBI (Bull-Bear Index)",     overlay: true,  cat: "Tendance" },
  { name: "BOLL", label: "Bollinger Bands",           overlay: true,  cat: "Volatilité" },
  { name: "SAR",  label: "SAR Parabolic",             overlay: true,  cat: "Tendance" },

  // ==== SOUS-PANNEAUX ====
  { name: "VOL",  label: "Volume + MA",               overlay: false, cat: "Volume" },
  { name: "MACD", label: "MACD",                      overlay: false, cat: "Momentum" },
  { name: "KDJ",  label: "KDJ / Stochastique",        overlay: false, cat: "Momentum" },
  { name: "RSI",  label: "RSI (Relative Strength)",   overlay: false, cat: "Momentum" },
  { name: "BIAS", label: "BIAS",                      overlay: false, cat: "Momentum" },
  { name: "BRAR", label: "BRAR",                      overlay: false, cat: "Momentum" },
  { name: "CCI",  label: "CCI (Commodity Channel)",   overlay: false, cat: "Momentum" },
  { name: "DMI",  label: "DMI / ADX",                 overlay: false, cat: "Tendance" },
  { name: "CR",   label: "CR (Yin-Yang)",             overlay: false, cat: "Momentum" },
  { name: "PSY",  label: "PSY (Psychologique)",       overlay: false, cat: "Sentiment" },
  { name: "DMA",  label: "DMA (Différence MA)",       overlay: false, cat: "Tendance" },
  { name: "TRIX", label: "TRIX",                      overlay: false, cat: "Momentum" },
  { name: "OBV",  label: "OBV (On Balance Volume)",   overlay: false, cat: "Volume" },
  { name: "VR",   label: "VR (Volume Ratio)",         overlay: false, cat: "Volume" },
  { name: "WR",   label: "Williams %R",               overlay: false, cat: "Momentum" },
  { name: "MTM",  label: "MTM (Momentum)",            overlay: false, cat: "Momentum" },
  { name: "EMV",  label: "EMV (Ease of Movement)",    overlay: false, cat: "Volume" },
  { name: "ROC",  label: "ROC (Rate of Change)",      overlay: false, cat: "Momentum" },
  { name: "AO",   label: "Awesome Oscillator",        overlay: false, cat: "Momentum" },
  { name: "PVT",  label: "PVT (Price Volume Trend)",  overlay: false, cat: "Volume" },
];

/** Nom → indicator config lookup */
export const INDICATOR_MAP = INDICATORS.reduce((acc, i) => { acc[i.name] = i; return acc; }, {});

/** Catégories dans l'ordre d'affichage */
export const CATEGORIES = ["Structure", "Tendance", "Momentum", "Volatilité", "Volume", "Sentiment"];

/** Indicateurs actifs par défaut — zones propriétaires visibles d'entrée */
export const DEFAULT_ACTIVE = ["ZII", "ZRI", "DP", "RL"];
